import { Values } from '@shared/utils/objectEnums';
import {
	Currencies,
	FuelTypes,
} from './constants';
import { formatCurrency } from './currency';
import { round } from './math';

type Props = {
	quantity: number | null | undefined;
	fuelGrade: Values<typeof FuelTypes>;
	pricePerTon?: number | null;
};

const getBunkerDescription = (
	{
		quantity,
		fuelGrade,
		pricePerTon,
	}: Props,
	currency: Values<typeof Currencies>,
) => {
	const quantityPrefix = quantity != null ? `${round(quantity, 3)}MT ` : '';

	return pricePerTon != null ?
		`${quantityPrefix}${fuelGrade} at ${formatCurrency(pricePerTon, currency)}/MT` :
		`${quantityPrefix}${fuelGrade}`;
};

export default getBunkerDescription;
